import { UseQueryOptions, useQuery } from 'react-query';
import { ExtraHeaders } from './useApiHeaders';
import { useIsAuthenticated } from '@azure/msal-react';
import { ObjectMap, ExtraQueryOptions, useApiGet, ApiError } from './api-hooks';

export function useApiQuery<TO = ObjectMap, TError = ApiError | undefined>(
  route: string,
  params?: ObjectMap,
  useQueryOptions?: UseQueryOptions<TO, TError>,
  extraHeaders?: ExtraHeaders,
  extraQueryOptions?: ExtraQueryOptions<TO>
) {
  const isAuthenticated = useIsAuthenticated();
  const apiGet = useApiGet<TO>(extraQueryOptions);
  // Wait for authorization
  const enabled =
    (isAuthenticated || !!extraQueryOptions?.isLogoutApi) &&
    (useQueryOptions?.enabled || useQueryOptions?.enabled === undefined);

  return useQuery<TO, TError>(
    useQueryOptions?.queryKey
      ? useQueryOptions?.queryKey
      : [route, params, extraHeaders],
    () => apiGet(route, params, extraHeaders),
    {
      ...useQueryOptions,
      enabled,
      retry: 0,
    }
  );
}
